// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1W0wxmKbu39IBH5WxF1pYb","text":"_25mInnbFm0URDHpPp-5W2Y"};